import confetti from "canvas-confetti"

// 纸屑动画
const Confetti = ({ particleCount = 250, spread = 55, zIndex = 2222 }) => {
  // 右侧纸屑
  confetti({
    particleCount,
    angle: 130,
    spread,
    origin: {
      x: 1,
      y: 0.6,
    },
    zIndex,
  })

  // 左侧纸屑
  confetti({
    particleCount,
    angle: 50,
    spread,
    origin: {
      x: 0,
      y: 0.6,
    },
    zIndex,
  })
}

export default Confetti
